// @ts-nocheck
import React, { useCallback } from 'react';
import { alpha, Box, useTheme } from '@mui/material';
import PropTypes from 'prop-types';

const ColorBox = ({ color, c, onColorSelect }) => {
  const theme = useTheme();

  const handleColorSelect = useCallback(() => {
    onColorSelect(c);
  }, [onColorSelect, c]);

  return (
    <Box
      key={c}
      onClick={handleColorSelect}
      sx={{
        width: '24px',
        height: '24px',
        backgroundColor: c,
        border:
          color === c
            ? `2px solid ${alpha(theme?.palette?.primary?.main, 1)}`
            : `1px solid ${alpha(theme?.palette?.primary?.main, 0.3)}`,
        cursor: 'pointer',
        '&:hover': {
          border: `2px solid ${alpha(theme?.palette?.primary?.main, 1)}`,
        },
      }}
    />
  );
};

ColorBox.propTypes = {
  color: PropTypes.string.isRequired,
  onColorSelect: PropTypes.func.isRequired,
  c: PropTypes.string.isRequired,
};

const ColorPicker = ({ onColorSelect, color }) => {
  const theme = useTheme();
  // Get color values from theme
  const { colorPicker } = theme.palette;

  const colors = [
    colorPicker?.black,
    colorPicker?.darkGray,
    colorPicker?.mediumGray,
    colorPicker?.gray,
    colorPicker?.lightGray,
    colorPicker?.lighterGray,
    colorPicker?.lightestGray,
    colorPicker?.nearWhite,
    colorPicker?.offWhite,
    colorPicker?.white,
    colorPicker?.darkRed,
    colorPicker?.red,
    colorPicker?.orange,
    colorPicker?.yellow,
    colorPicker?.green,
    colorPicker?.cyan,
    colorPicker?.blue,
    colorPicker?.brightBlue,
    colorPicker?.purple,
    colorPicker?.magenta,
  ];

  return (
    <Box
      sx={{
        p: 1,
        display: 'flex',
        flexWrap: 'wrap',
        width: '200px',
        gap: '4px',
      }}
    >
      {colors.map((c) => (
        <ColorBox key={c} c={c} onColorSelect={onColorSelect} color={color} />
      ))}
    </Box>
  );
};

ColorPicker.propTypes = {
  onColorSelect: PropTypes.func.isRequired,
  color: PropTypes.string.isRequired,
};

export default ColorPicker;
